import dagre from "@dagrejs/dagre";
import { Edge, Node } from "@xyflow/react";
import { FlowOrientation } from "@/model/interface/CallFlow";

export const FLOW_NODE_WIDTH = 340;
const FALLBACK_NODE_HEIGHT = 160;
const SIBLING_GAP = 56;
const RANK_GAP = 80;

export function layoutFlow(nodes: Node[], edges: Edge[], orientation: FlowOrientation): Node[] {
  const graph = new dagre.graphlib.Graph();
  graph.setDefaultEdgeLabel(() => ({}));
  graph.setGraph({
    rankdir: orientation === "horizontal" ? "LR" : "TB",
    nodesep: SIBLING_GAP,
    ranksep: RANK_GAP,
  });

  nodes.forEach((node) => {
    graph.setNode(node.id, {
      width: node.measured?.width || FLOW_NODE_WIDTH,
      height: node.measured?.height || FALLBACK_NODE_HEIGHT,
    });
  });

  edges.forEach((edge) => {
    if (edge.source !== edge.target && graph.hasNode(edge.source) && graph.hasNode(edge.target)) {
      graph.setEdge(edge.source, edge.target);
    }
  });

  dagre.layout(graph);

  return nodes.map((node) => {
    const placed = graph.node(node.id);
    const position = {
      x: Math.round(placed.x - placed.width / 2),
      y: Math.round(placed.y - placed.height / 2),
    };
    if (node.position.x === position.x && node.position.y === position.y) {
      return node;
    }
    return { ...node, position };
  });
}
